import { createSelector } from "reselect";

import { EntityTypesSupportingFieldCustomization } from "@mapmycustomers/shared/types/entity";
import FormLayout, {
  ChildLayout,
  LayoutSchemaField,
} from "@mapmycustomers/shared/types/layout/FormLayout";

import { RootState } from "@app/store/rootReducer";

const layoutState = (state: RootState) => state.layout;

export const getLayouts = createSelector(layoutState, ({ layouts }) => layouts);

export const getLayoutsForEntity = createSelector(
  [getLayouts, (_, entityType: EntityTypesSupportingFieldCustomization) => entityType],
  (
    layoutsMap: Record<EntityTypesSupportingFieldCustomization, FormLayout[]>,
    entityType
  ): FormLayout[] => layoutsMap[entityType]
);

export type LayoutSchemaGetter = (
  entityType: EntityTypesSupportingFieldCustomization,
  layoutId: FormLayout["id"],
  variantProperties?: Omit<ChildLayout, "id" | "schema">
) => LayoutSchemaField[];
